// Self-hosted variable Inter (registers font-family "Inter Variable") — the
// CloudFront CSP is default-src 'self', so no font CDN.
import '@fontsource-variable/inter';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';

import { App } from '@/App';
import { config } from '@/config';

if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.sentryEnv,
    tracesSampleRate: config.sentryEnv === 'production' ? 0.01 : 0.1,
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root missing from index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
